module.exports = __webpack_public_path__ + "static/media/IVah.2a6ca26d.png";